export default {
  // Beginner guide
  finishButton: "Finish",

  // Input and search
  addressPlaceholder: "Please enter address or investigation user ID",
  queryButton: "Query",

  // Label management
  labelManagement: "Label Management",
  addLabel: "Add Label",

  // Empty state
  emptyMessage:
    "Please enter address or investigation user ID to query corresponding labels",
  loading: "Loading...",

  // Label information
  recentOperator: "Recent operator",
  modifyButton: "Modify",
  balance: "Balance",

  // Delete confirmation
  deleteConfirmTitle: "Notice",
  deleteConfirmMessage: "Do you want to delete this label?",
  no: "No",
  yes: "Yes",
  deleteSuccess: "Delete successful!",
  deleteCanceled: "Delete canceled",

  // Label dialog
  addLabelTitle: "Add Label",
  modifyLabelTitle: "Modify Label",
  labelSelect: "Label",
  pleaseSelect: "Please select",
  pleaseInput: "Please enter content",
  cancel: "Cancel",
  confirm: "Confirm",
  addNew: "Add New",

  // Validation messages
  requiredFieldError: "Required fields marked with * must be filled",
  pleaseEnterAddress: "Please enter address or investigation user ID",

  // Review related
  reviewTitle: "Label Review Notice",
  reviewMessage:
    "The current address label contains key attributes and needs to wait for administrator approval before taking effect.",
  submitSuccessWithReview:
    "Submitted successfully, will be visible in {productName} after administrator approval",
  addLabelSuccess: "This data has been successfully labeled",
  modifyLabelSuccess: "Label modified successfully!",

  // Delete operation
  deleteConfirm: "Confirm to delete current label?",

  // Copy function
  copySuccess: "Copy successful!",

  // Form validation tips
  pleaseSelectOption: "Please select",
  pleaseInputField: "Please enter {field}",

  // tagdetialfn.js related strings
  // Delete confirmation
  deleteConfirmMessage:
    "This operation will permanently delete this label, continue?",
  deleteConfirmTitle: "Notice",

  // Button text
  confirm: "Confirm",
  cancel: "Cancel",

  // Success messages
  addLabelSuccess: "This node has been successfully tagged",
  deleteLabelSuccess: "Label deleted successfully!",
  deleteCanceled: "Delete canceled",

  // Platform address
  platformAddress: "Platform Address",
};
